<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'" ref="content">
            <Row style="margin-bottom: 20px">
                <label>项目名称</label>
                <Select
                        v-model="filter.projIds"
                        clearable
                        placeholder="全部"
                        :disabled="loading"
                        :class="preCls + 'select-public-style'"
                >
                    <Option
                            v-for="(item, index) in projList"
                            :key="index"
                            :value="item.id"
                    >{{item.projName}}
                    </Option>
                </Select>
                <label>开始日期</label>
                <date-picker
                        :disabled="loading"
                        :class="preCls + 'select-public-style'"
                        v-model="startTime"
                        transfer
                        type="date"
                ></date-picker>
                <label>结束日期</label>
                <date-picker
                        :disabled="loading"
                        :class="preCls + 'select-public-style'"
                        v-model="endTime"
                        transfer
                        type="date"
                ></date-picker>
                <check-tag-group style="display: inline-block;" v-model="near" color="primary">
                    <check-tag
                            :disabled="loading"
                            v-for="(item, index) in nearList"
                            style="height: 32px; line-height: 32px"
                            :name="item.id"
                            :key="index"
                    >{{item.text}}
                    </check-tag>
                </check-tag-group>
            </Row>
            <Tabs :animated="false" v-model="active">
                <TabPane label="报备客户" :index="1" name="cusReport">
                    <Access name="cusReport">
                        <router-view
                                v-if="active == 'cusReport'"
                                customerStatus="1"
                                :propFilter="filter"
                                :name="$access.aliasToUri('cusReport')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="到访客户" :index="2" name="cusVisit">
                    <Access name="cusVisit">
                        <router-view
                                v-if="active == 'cusVisit'"
                                customerStatus="2"
                                :propFilter="filter"
                                noticeType="1"
                                :name="$access.aliasToUri('cusVisit')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="成交客户" :index="3" name="cusFinish">
                    <Access name="cusFinish">
                        <router-view
                                v-if="active == 'cusFinish'"
                                customerStatus="3"
                                :propFilter="filter"
                                noticeType="2"
                                :name="$access.aliasToUri('cusFinish')"
                        ></router-view>
                    </Access>
                </TabPane>
                <TabPane label="结佣客户" :index="4" name="cusWindup">
                    <Access name="cusWindup">
                        <router-view
                                v-if="active == 'cusWindup'"
                                customerStatus="4"
                                :propFilter="filter"
                                noticeType="3"
                                :name="$access.aliasToUri('cusWindup')"
                        ></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
    import {projList} from '@/api/proj-manager'
    import dayjs from 'dayjs'

    const clog = console.log;

    export default {
        data() {
            return {
                projList: [],
                filter: {
                    projIds: this.$cache.projIds,
                    startTime: this.$cache.startTime,
                    endTime: this.$cache.endTime
                },
                loading: false,
                active: this.$cache.currentTab,
                nearList: [
                    {
                        id: 7,
                        text: '近7天'
                    },
                    {
                        id: 30,
                        text: '近30天'
                    },
                    {
                        id: 90,
                        text: '近90天'
                    }
                ]
            }
        },
        computed: {
            startTime: {
                get() {
                    return this.filter.startTime ? new Date(this.filter.startTime) : '';
                },
                set(val) {
                    this.filter.startTime = val ? dayjs(val).format('YYYY-MM-DD') : '';
                }
            },

            endTime: {
                get() {
                    return this.filter.endTime ? new Date(this.filter.endTime) : '';
                },
                set(val) {
                    this.filter.endTime = val ? dayjs(val).format('YYYY-MM-DD') : ''
                }
            },
            near: {
                get() {
                    return [
                        dayjs(this.filter.endTime).diff(this.filter.startTime, 'day')
                    ]
                },
                set(val) {
                    let days = val[0]

                    if (days) {
                        this.filter.endTime = dayjs().format('YYYY-MM-DD')
                        this.filter.startTime = dayjs()
                            .subtract(days, 'day')
                            .format('YYYY-MM-DD')
                    }
                }
            }
        },
        watch: {
            'filter.projIds': function (el) {
                this.$cache.projIds = el
            },
            'filter.startTime': function (el) {
                this.$cache.startTime = el
            },
            'filter.endTime': function (el) {
                this.$cache.endTime = el
            },
            'active': function(el){
                this.$cache.currentTab = el
            }
        },
        mounted() {
            window.t = this
            this.loading = true;
            this.near = [30];//默认搜索近30天
            let body = {
                page: 1,
                pageSize: 999
            }
            projList(body)
                .then(res => {
                    this.projList = res.data.page.list
                })
                .finally(() => (this.loading = false))
        }
    }
</script>
<style lang="less"
       scoped>
</style>